export default "__VITE_PUBLIC_ASSET__141ce34f__"